 <template>
    <modal
        size="lg"
        :open="show"
        @closeModal="
            show = false;
            $emit('closeModal');
        "
        @closeModalAndFetch="
            show = false;
            $emit('closeAndFetchModal');
        "
    >
        <form
            class="flex w-full flex-col flex-wrap space-y-3 text-gray-900 dark:text-white"
            @submit.prevent="submit"
        >
            <h1 class="border-b border-slate-500 pb-2">
                Reembolsar e Sinalizar Fraude
            </h1>
            <label for="reason" class="sr-only">Reason</label>

            <div v-if="errors.length > 0" class="alert">
                <div v-for="error in errors" :key="error">
                    {{ error }}
                </div>
            </div>

            <p>
                <strong>Atenção:</strong> Prosseguindo, essa transação será
                estornada e classificada como fraude.
            </p>

            <div class="mt-5 flex flex-row-reverse">
                <submit-button
                    :loading="loading"
                    :disabled="loading"
                    @keydown.enter="submit"
                >
                    Enviar
                </submit-button>

                <button
                    :disabled="loading"
                    type="button"
                    class="mr-2 inline-flex justify-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-300 sm:mt-0 sm:w-auto sm:text-sm"
                    @click="$emit('closeModal')"
                >
                    Cancelar
                </button>
            </div>
        </form>
    </modal>
</template>

<script>
import Modal from "../../../components/layouts/Modal.vue";
import SubmitButton from "../../../components/forms/SubmitButton.vue";

export default {
    props: ["transaction", "show"],
    components: { SubmitButton, Modal },

    data() {
        return {
            loading: false,
            reason: null,
            errors: [],
            message: null,
        };
    },

    methods: {
        submit() {
            this.errors = [];
            this.message = null;
            this.loading = true;

            axios
                .post(
                    "/api/order/" +
                        this.transaction.order_id +
                        "/transactions/" +
                        this.transaction.id +
                        "/refund",
                    {
                        refund_type: "fraud",
                        fraud_confirmed: true,
                        skip_balance: "SKIP",
                    },
                )
                .then(({ data }) => {
                    this.loading = false;
                    this.$emit("closeModalAndFetch");

                    this.$notify(
                        {
                            group: "success",
                            title: "Success",
                            text:
                                data?.message ||
                                "Solicitação realizada com sucesso!",
                        },
                        4000,
                    );
                })
                .catch((error) => {
                    const response = error?.response;
                    const data = response?.data;
                    const isTimeout =
                        !response ||
                        response.status === 504 ||
                        error?.code === "ECONNABORTED" ||
                        data?.inconclusive === true;

                    if (isTimeout) {
                        this.$emit("closeModalAndFetch");
                        this.$notify(
                            {
                                group: "success",
                                title: "Processamento em andamento",
                                text:
                                    data?.message ||
                                    "A solicitação pode ter sido aceita. Atualizamos a lista — confira o status antes de tentar novamente.",
                            },
                            8000,
                        );
                        return;
                    }

                    const errors = Array.isArray(data?.errors)
                        ? data.errors
                        : data?.errors
                          ? Object.values(data.errors).flat()
                          : [];
                    const rawMessage =
                        errors[0] ||
                        data?.message ||
                        "Não foi possível concluir essa solicitação.";
                    const message = /curl\s*error|cURL error|ECONNABORTED|timed out/i.test(
                        String(rawMessage),
                    )
                        ? "A solicitação demorou para responder. Atualize a página e verifique o status antes de tentar novamente."
                        : rawMessage;

                    this.errors = errors.length ? [message] : [message];

                    this.$notify(
                        {
                            group: "error",
                            title: "Erro",
                            text: message,
                        },
                        4000,
                    );

                    this.loading = false;
                });
        },
    },
};
</script>
